import React from "react";
import { useLocalization } from "@i18n";
import { GeneralDashboardCard } from "./GeneralDashboardCard";
import { ClassificationBignumberCard } from "./ClassificationBignumberCard";
import { GeneralDashboardRegionalPreview } from "../api/generalDashboard/generalDashboard.types";
import { formatClassificationBandLabel } from "../utils/formatClassificationBandLabel";

interface GeneralRegionalClassificationCardProps {
  data: GeneralDashboardRegionalPreview | null;
  onMenuClick: () => void;
}

export const GeneralRegionalClassificationCard: React.FC<
  GeneralRegionalClassificationCardProps
> = ({ data, onMenuClick }) => {
  const { translate } = useLocalization();

  return (
    <GeneralDashboardCard
      title={translate("general.dashboard.regionalClassification.title")}
      onMenuClick={onMenuClick}
    >
      <div className="general-dashboard-bignumber-row">
        <ClassificationBignumberCard
          label={translate("general.dashboard.regionalClassification.dpa")}
          displayValue={formatClassificationBandLabel(
            translate,
            data?.dpa?.classificationLevel,
          )}
          level={data?.dpa?.classificationLevel}
        />
        <ClassificationBignumberCard
          label={translate("general.dashboard.regionalClassification.cri")}
          displayValue={formatClassificationBandLabel(
            translate,
            data?.cri?.classificationLevel,
          )}
          level={data?.cri?.classificationLevel}
        />
      </div>
    </GeneralDashboardCard>
  );
};
